<template>
  <div class="p-subaccounts g-page">
    <v-button type="cta-1" class="create-button"
      :action="openCreateModal"
      data-test="button-new-user">
        <icon name="plus" />
        <span>New Subaccount</span>
    </v-button>
    <v-table
      :loading="pageLoading"
      :thead="[
        { value: 'Name', width: 40 },
        { value: 'Email', width: 60 }]"
      :tbody="results"
      :columns="['name', 'email']"
      noResultsMessage="No contacts were found."
      data-test="subaccounts-table" />
    <v-paginate
      :loading="results.length > $store.state.subaccounts.pagingLimit"
      storeAction="subaccounts/PAGINATE"
      :current="$store.getters['subaccounts/currentPage'] + 1"
      :last="$store.getters['subaccounts/totalPages']"
      :showUrl="false" />
    <v-dynamic-loader
      viewURL="modals/CreateEditSubaccountModal"
      :data="{
        accountDetails: account.details,
        type: modalType,
        storeAction,
      }" />
  </div>
</template>

<script>
import { VButton } from '@signable/ui-kit/src/atoms';
import { VPaginate, VTable } from '@signable/ui-kit/src/molecules';

export default {
  name: 'subAccounts',
  components: {
    VButton,
    VPaginate,
    VTable,
  },
  data() {
    return {
      loading: true,
      storeAction: '',
      modalType: 'edit',
      account: {
        details: {
          name: null,
          email: null,
        },
      },
      // isSearching: false,
    };
  },
  created() {
    this.$store.dispatch('subaccounts/PAGINATE', { page: 1 }).then(() => {
      this.loading = false;
    });
  },
  computed: {
    results() {
      return this.$store.getters['subaccounts/pagedResults'];
    },
    pageLoading() {
      if (this.loading) {
        return true;
      }

      return false;
    },
  },
  methods: {
    resetAccountDetails() {
      this.account.details = {
        name: null,
        email: null,
      };
    },
    openCreateModal() {
      console.log('Open Account Modal');
      this.resetAccountDetails();
      this.storeAction = 'subaccounts/CREATE';
      this.modalType = 'create';
      this.$bus.$emit('toggleModal', { name: 'subaccount-create-edit-modal', active: true });
    },
  },
};
</script>

<style lang="scss">
  @import '../styles/manifest.scss';

  .create-button {
    margin-bottom: $spacing-base;
    float: right !important;
    margin-right: 1px;
  }

</style>
